export function useComplatibleLocale(locale: string) {
  if (!locale) throw new Error('no locale set')

  return locale.replace(/^(ar(?:-[A-Za-z]{2})?)(?:-u-nu-[A-Za-z]+)?$/i, '$1-u-nu-latn')
}
